<script>
    import {getGPTransFunc} from "./gp-translations.js";
    import jQuery from "jquery";
    import {GPContextItems, activePickerSnippet, snippetFlip} from "./gp-context-items";
    import {snippetsStore} from './gp.js';
    import {tick} from 'svelte';
    import GPSnippetItem from "./gp-snippetpickeritem.svelte"
    import {fade} from 'svelte/transition';
    import {flip} from 'svelte/animate';
    import { onMount } from 'svelte';

    let trans = getGPTransFunc("gp-snippetpicker");
    let initialItemsLimit = 50;
    let itemsLimit = 50;
    let itemsVisibleCount;
    let overLimitCount;
    let snippets = [];

    $: {snippets = $snippetsStore; update()}

    let elemsInRow = null;

    onMount(() => {
        jQuery(window).off('resize', onResize);
        jQuery(window).on('resize', onResize);

        var chk_scroll = function (e) {
            var elem = jQuery(e.currentTarget);
            if (elem[0].scrollHeight - elem.scrollTop() - 10 < elem.outerHeight()) loadMore();
        };
        jQuery('#GPSnippetPickerList').bind('scroll', chk_scroll);

        update();
        if (!$activePickerSnippet) selectFirstItem();
        onResize();
    })

    function update() {
        itemsVisibleCount = 0;
        let allFittingCount = 0;
        snippets = snippets.map((el, i) => {
            el.visible = true;

            if (el.visible) {
                allFittingCount += 1;
            }
            if (itemsVisibleCount > itemsLimit) el.visible = false;
            if (el.visible) {
                itemsVisibleCount += 1;
            }

            return el;
        });
        resortSnippets();
        overLimitCount = allFittingCount - itemsVisibleCount;
    }

    function resortSnippets () {
        snippets.sort(function (a, b) {
            var an = a.name.replace("'","");
            var bn = b.name.replace("'","");
            if (a.own) an = "Z"+an; else an = "A"+an;
            if (b.own) bn = "Z"+bn; else bn = "A"+bn;
            if (!a.enabled) an = "Z"+an; else an = "A"+an;
            if (!b.enabled) bn = "Z"+bn; else bn = "A"+bn;
            if (an < bn)
                return -1;
            if (an > bn)
                return 1;
            return 0;
        });
    }

    function loadMore(uptoIdx) {
        if (overLimitCount === 0) return;
        let addAmount = uptoIdx ? uptoIdx : initialItemsLimit;
        itemsLimit += addAmount;
        update();
    }

    function selectItem(snippet) {
        $activePickerSnippet = snippet;
        $snippetFlip = false;
    }

    export function selectFirstItem() {
        selectItem(snippets.filter((e) => e.visible)[0]);
        scrollToSelected();
    }

    function scrollToSelected() {
        setTimeout(async () => {
            await tick();
            let el = jQuery('.GPSnippetPickerItem.selected');
            if (el) {
                let main = jQuery("#GPSnippetPickerList");
                let top = jQuery(".GPSnippetPickerItem").eq(0).parent().position().top;
                let t = el.position().top;
                main.animate({scrollTop: -top + t}, 100);
            }
        }, 500)
    }

    function selectNextItem(step) {
        let displayedObjs = snippets.filter((e) => e.visible);
        let newActiveIndex = displayedObjs.indexOf($activePickerSnippet) + step;
        if (newActiveIndex >= displayedObjs.length) newActiveIndex = displayedObjs.length - 1;
        $activePickerSnippet = displayedObjs[newActiveIndex];
        scrollToSelected();
    }

    function selectPrevItem(step) {
        let displayedObjs = snippets.filter((e) => e.visible);
        let newActiveIndex = displayedObjs.indexOf($activePickerSnippet) - step;
        if (newActiveIndex < 0) newActiveIndex = 0;
        $activePickerSnippet = displayedObjs[newActiveIndex];
        scrollToSelected();
    }

    function handleKeyboard(e) {
        if (!$activePickerSnippet || !(jQuery(".GPPickerArea.active").length)) return;
        switch (e.which) {
            case 37: // left
                selectPrevItem(1);
                break;

            case 38: // up
                selectPrevItem(elemsInRow);
                break;

            case 39: // right
                selectNextItem(1);
                break;

            case 40: // down
                selectNextItem(elemsInRow);
                break;

            case 32: // space
                GPContextItems.addSnippetAtDefaultPos();
                break;

            default:
                return; // exit this handler for other keys
        }
        e.preventDefault(); // prevent the default action (scroll / move caret)
    }


    function resetPicker() {
        selectFirstItem();
    }


    export function onResize() {
        var pickerW = jQuery('.GPPickerArea').innerWidth();
        elemsInRow = Math.floor(pickerW / 180);
        jQuery('#GPSnippetPickerList').css('grid-template-columns', 'repeat(' + elemsInRow + ', 1fr)');
    }

</script>

<svelte:window on:keydown={handleKeyboard} on:GPNewProject={resetPicker}/>

<li on:click={()=>GPSettings.storageClass.ensureLogged(GP.saveSnippet)} class="list-group-item enabled GPSnippetPickerAddItem">
    <i class="fa fa-plus-circle fa-2x"></i>
</li>
{#each snippets.filter(el => el.visible) as snippet (snippet.id)}
    <li out:fade animate:flip={{duration: 200}}>
        <GPSnippetItem snippet={snippet}/>
    </li>
{/each}

{#if overLimitCount > 0}
    <li class="list-group-item GPSnippetPickerItem " on:click={loadMore}>
        <div class="GPSnippetPickerMoreAvailable">
            + {overLimitCount} {trans( "more")}<br/>
            {trans( "click to load more or use filters")}
        </div>
    </li>
{/if}

